import React, { useEffect, useRef } from 'react';
import axios from 'axios';
import bundle from '../marketing/radio.generated.json';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const FONTS_HREF =
  'https://fonts.googleapis.com/css2?family=Bungee&family=Bungee+Shade&family=Modak&family=Permanent+Marker&family=Inter:wght@400;500;600;700&family=Space+Grotesk:wght@400;500;600;700&display=swap';

/**
 * MusicBooth Radio ("/radio", deep-linkable via "/radio#<world-id>").
 * The founder-approved prototype is ported verbatim and mounted as a React
 * component. Track lists come from the DB (/radio/worlds) and the live
 * listener count from /radio/presence — no fabricated numbers. All CSS/JS is
 * torn down on unmount so nothing bleeds onto the logged-in app.
 */
export default function RadioPage() {
  const hostRef = useRef(null);

  useEffect(() => {
    let cancelled = false;
    const prevTitle = document.title;
    document.title = 'MusicBooth Radio — pick a world, feel the vibe';
    window.__RADIO_API = API;

    const fonts = document.createElement('link');
    fonts.rel = 'stylesheet';
    fonts.href = FONTS_HREF;
    fonts.setAttribute('data-mkt', '1');
    document.head.appendChild(fonts);

    const style = document.createElement('style');
    style.setAttribute('data-mkt', '1');
    style.textContent = bundle.css;
    document.head.appendChild(style);

    const boot = async () => {
      // DB-backed per-world track lists + ordering/visibility (falls back to
      // baked defaults on error).
      try {
        const r = await axios.get(`${API}/radio/worlds`);
        window.__RADIO_TRACKS = r.data?.worlds || null;
        window.__RADIO_META = (r.data?.order || r.data?.visible)
          ? { order: r.data?.order || [], visible: r.data?.visible || [] }
          : null;
      } catch {
        window.__RADIO_TRACKS = null;
        window.__RADIO_META = null;
      }
      if (cancelled || !hostRef.current) return;
      hostRef.current.innerHTML = bundle.body;
      const script = document.createElement('script');
      script.setAttribute('data-mkt', '1');
      script.textContent = bundle.js;
      document.body.appendChild(script);
    };
    boot();

    return () => {
      cancelled = true;
      try { if (typeof window.__mktCleanup === 'function') window.__mktCleanup(); } catch { /* noop */ }
      document.querySelectorAll('[data-mkt="1"]').forEach((n) => n.remove());
      if (hostRef.current) hostRef.current.innerHTML = '';
      document.title = prevTitle;
      delete window.__RADIO_API;
      delete window.__RADIO_TRACKS;
      delete window.__RADIO_META;
      delete window.__RADIO_ONLINE;
    };
  }, []);

  return <div ref={hostRef} data-testid="radio-site" />;
}
